export default __webpack_public_path__ + "static/media/cartao-de-entrada.450a07fe.svg";